import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';

const messages = {
	'fr-FR': {
		'nav.dashboard': 'Dashboard',
		'nav.memories': 'Mes Souvenirs',
		'nav.libraries': 'Bibliothèques',
		'nav.account': 'Mon Compte',
		'nav.pricing': 'Abonnement',
		'nav.stats': 'Statistiques',
		'nav.settings': 'Paramètres',
		'nav.logout': 'Se déconnecter',
		'nav.memory3d': 'Mémoire 3D',
		'nav.extension': 'Extension',

		'common.soon': 'Bientôt',
		'common.close': 'Fermer',
		'common.all': 'Tous',

		'actions.import': 'Importer',
		'actions.add': 'Ajouter',
		'actions.addDocuments': 'Ajouter des documents',
		'actions.importLink': 'Importer un lien',
		'actions.save': 'Enregistrer',
		'actions.saving': 'Enregistrement…',

		'common.loading': 'Chargement…',
		'common.retry': 'Réessayer',
		'common.refresh': 'Actualiser',
		'common.noData': 'Aucune donnée.',

		'dashboard.subtitle': 'Gérez votre espace de travail IA',
		'dashboard.storage': 'Espace de stockage',
		'dashboard.vectorsUsed': 'Vecteurs utilisés',
		'dashboard.spaceFree': "{percent}% d'espace libre restant",
		'dashboard.memoryRequests': 'Requêtes mémoire',
		'dashboard.requestsOfQuota': 'sur {quota} autorisées',
		'dashboard.used': 'utilisées',
		'dashboard.requestsRemaining': '{count} requête{suffix} restantes ce mois',
		'dashboard.memoryHistory': 'Historique mémoire',
		'dashboard.loadingMemories': 'Chargement des mémoires…',
		'dashboard.noMemories': 'Aucune mémoire trouvée.',
		'dashboard.viewAllHistory': "Voir tout l'historique",
		'dashboard.aiPermissions': 'Permissions IA',
		'dashboard.loadingPermissions': 'Chargement des permissions...',
		'dashboard.permissionsSaved': 'Permissions sauvegardées.',
		'dashboard.saveErrorPrefix': 'Erreur de sauvegarde:',

		// Limites atteintes
		'limits.title': 'Limite atteinte',
		'limits.desc': 'Vous avez atteint la limite de votre plan gratuit. Passez à un plan supérieur pour continuer sans interruption.',
		'limits.reached.requests': '{used} / {quota} requêtes',
		'limits.reached.vectors': '{used} / {quota} vecteurs',
		'limits.btn.close': 'Fermer',
		'limits.btn.upgrade': 'Voir les plans',
		'limits.btn.cleanup': 'Libérer de la place',

		'stats.title': 'Statistiques',
		'stats.weeklyRequests': 'Requêtes (semaine)',
		'stats.requestsRemaining': '{remaining} restantes sur {quota}',
		'stats.vectors': 'Vecteurs',
		'stats.vectorsRemaining': '{remaining} restants sur {quota}',
		'stats.distinctCategories': 'Catégories distinctes',
		'stats.basedOnHistory': "Basé sur l'historique mémoire",
		'stats.byCategory': 'Répartition par catégorie',
		'stats.items': '{count} élément{suffix}',
		'stats.vectorCloud': 'Nuage 3D des vecteurs',
		'stats.points': 'points',
		'stats.previewNote': 'Aperçu basé sur total_vectors.',
		'stats.loading': 'Chargement des statistiques…',

		'memory3d.title': 'Votre mémoire',
		'memory3d.subtitle': "Plongez dans l'univers de vos pensées et découvrez vos souvenirs cachés",
		'memory3d.pointsShown': 'Points affichés:',
		'memory3d.soonInputPlaceholder': 'Parlez à votre mémoire...',
		'memory3d.tooltipTitle': 'Chat avec votre mémoire',
		'memory3d.tooltipBody': 'Vous pourrez bientôt questionner votre mémoire pour trouver des infos et répondre à vos questions personnelles',

		'settings.title': 'Paramètres',
		'settings.profile': 'Profil',
		'settings.language': 'Langue',
		'settings.theme': 'Thème',

		'mcp.title': 'Connexion serveur MCP',
		'mcp.badge': 'Bientôt',
		'mcp.description': 'Créez un jeton pour vous authentifier auprès d’un serveur MCP. L’intégration côté serveur arrive bientôt.',
		'mcp.none': 'Aucun jeton pour le moment.',
		'mcp.copy': 'Copier',
		'mcp.delete': 'Supprimer',
		'mcp.createToken': 'Créer un token',
		'mcp.soonTitle': 'Bientôt disponible',
		'mcp.soonText': 'La création de jetons MCP arrive prochainement. Merci de votre patience.',

		'security.title': 'Sécurité',
		'security.tip1': 'Vos jetons sont stockés uniquement dans votre navigateur.',
		'security.tip2': 'Déconnectez-vous pour effacer les jetons d’authentification.',

	'support.title': 'Support',
	'support.proText': 'Si vous avez un un probleme contactez : hiperyon@gmail.com',
	'support.discordButton': 'Support Discord',

		'library.title': 'Bibliothèques',
		'library.intro1': 'Organisez et incluez des documents pour enrichir les réponses du modèle. Les fichiers seront vectorisés et consultables par vos conversations.',
		'library.intro2': "Fonctionnalité en cours de préparation. Essayez les actions ci-dessous pour voir l'aperçu.",
		'library.newLibrary': 'Nouvelle bibliothèque',
		'library.noDocument': 'Aucun document',
		'library.createdBy': 'Créé par {email}',
		'library.count': '{count} bibliothèque{suffix}',
		'library.lastUpdated': 'Dernière mise à jour',

		'notfound.title': 'Page introuvable',
		'notfound.text': "La page que vous cherchez n'existe pas ou a été déplacée.",
		'notfound.dashboard': 'Aller au Dashboard',
		'notfound.memories': 'Repreen de la memoire',
		'notfound.libraries': 'Bibliothèques',

		'souvenirs.title': 'Mes Souvenirs',

		'auth.login.title': 'Se connecter',
		'auth.login.subtitle': 'Ravi de vous revoir',
		'auth.email': 'Email',
		'auth.password': 'Mot de passe',
		'auth.forgot': 'Mot de passe oublié ?',
		'auth.or': 'ou',
		'auth.login.submit': 'Se connecter',
		'auth.login.submitting': 'Connexion...',
		'auth.login.noAccount': 'Pas de compte ?',
		'auth.signup.link': 'Créer un compte',
		'auth.error.server': 'Erreur de connexion au serveur',
		'auth.error.invalid': 'Identifiants incorrects',

		'auth.signup.title': 'Créer un compte',
		'auth.signup.subtitle': 'Rejoignez-nous maintenant',
		'auth.pseudo': 'Pseudo',
		'auth.signup.submit': 'Créer le compte',
		'auth.signup.submitting': 'Création...',
		'auth.signup.success': 'Compte créé avec succès ! Vous pouvez maintenant vous connecter.',
		'auth.signup.haveAccount': 'Déjà un compte ?',
		'auth.login.link': 'Se connecter',
		'auth.password.strength': 'Force du mot de passe',
		'auth.password.veryWeak': 'Très faible',
		'auth.password.weak': 'Faible',
		'auth.password.medium': 'Moyen',
		'auth.password.strong': 'Fort',
		'auth.password.requirement.min8': 'Au moins 8 caractères',
		'auth.password.requirement.special': 'Caractère spécial (!@#$%...)',
		'auth.password.requirement.uppercase': 'Lettre majuscule (A-Z)',
		'auth.password.requirement.number': 'Chiffre (0-9)',

		// Onboarding
		'onboarding.step': 'Étape',
		'onboarding.welcome': 'Bienvenue dans Hiperyon',
		'onboarding.welcomeDesc': 'Merci de nous aider à mieux vous connaître',
		'onboarding.helpDesc': 'Cette information nous aide à personnaliser votre expérience',
		'onboarding.ageQuestion': 'Quel est votre âge ?',
		'onboarding.ageHelper': 'Vous pouvez passer cette étape si vous préférez',
		'onboarding.usageQuestion': 'Quel est votre usage principal ?',
		'onboarding.usageHelper': 'Cela aide à optimiser les modèles recommandés',
		'onboarding.modelQuestion': 'Quels LLM utilisez-vous ?',
		'onboarding.modelHelper': 'Sélectionnez tous les modèles que vous utilisez régulièrement',
		'onboarding.frequenceQuestion': 'Combien de jours par semaine ?',
		'onboarding.frequenceHelper': 'Environ combien de jours par semaine utilisez-vous un LLM ?',
		'onboarding.frequence1day': '1 jour',
		'onboarding.frequence2to3': '2-3 jours',
		'onboarding.frequence4to5': '4-5 jours',
		'onboarding.frequence5plus': 'Plus de 5 jours',
		'onboarding.subscriptionQuestion': 'Choisissez votre abonnement',
		'onboarding.subscriptionRecommendLow': "L'offre Voyageur est parfaite pour commencer.",
		'onboarding.subscriptionRecommendMed': 'Vous utilisez l\'IA souvent. L\'offre Pro est idéale pour vous.',
		'onboarding.subscriptionRecommendHigh': 'Vous utilisez l\'IA très régulièrement ! Nous recommandons l\'offre Max.',
		'onboarding.yourProfile': 'Votre profil',
		'onboarding.age': 'Âge',
		'onboarding.usage': 'Usage',
		'onboarding.model': 'Modèle',
		'onboarding.frequence': 'Fréquence',
		'onboarding.notSet': 'Non renseigné',
		'onboarding.calculating': 'Nous calculons le meilleur abonnement',
		'onboarding.calculatingDesc': 'Basé sur votre profil, nous trouvons l\'offre la plus adaptée pour vous...',
		'onboarding.chooseLater': 'Choisir plus tard',
		'onboarding.next': 'Suivant',
		'onboarding.back': 'Retour',
		'onboarding.skip': 'Passer',
		'onboarding.planVoyageur': 'Voyageur',
		'onboarding.planPro': 'Pro',
		'onboarding.planMax': 'Max',
		'onboarding.planFree': 'Gratuit',
		'onboarding.recommended': 'Recommandé',
		'onboarding.popular': 'Populaire',
		'onboarding.usageWork': 'Travail & Productivité',
		'onboarding.usageStudy': 'Études & Apprentissage',
		'onboarding.usagePersonal': 'Usage Personnel',

		// Tutorial
		'tutorial.dashboard.welcome': 'Bienvenue dans Hiperyon',
		'tutorial.dashboard.welcome.desc': 'Découvrez comment utiliser Hiperyon en 2 minutes.',
		'tutorial.dashboard.storage': 'Votre Espace de Stockage',
		'tutorial.dashboard.storage.desc': 'Suivez votre consommation de vecteurs, 1 vecteur = 1 souvenir stocké.',
		'tutorial.dashboard.requests': 'Requêtes de Mémoire',
		'tutorial.dashboard.requests.desc': 'Chaque question à votre mémoire consomme une requête. Un ajout mémoire en consomme une aussi.',
		'tutorial.dashboard.permissions': 'Permissions IA',
		'tutorial.dashboard.permissions.desc': 'Contrôlez par IA si vous souhaitez que ces modèles ajoutent des données à votre mémoire ou puissent lire les données de votre mémoire.',
		'tutorial.dashboard.video': 'Regardez ce tutoriel pour mieux comprendre le dashboard.',
		'tutorial.souvenirs.title': 'Mes Souvenirs',
		'tutorial.souvenirs.title.desc': 'Votre base de données personnelle d\'informations stockées dans Hiperyon.',
		'tutorial.souvenirs.manage': 'Gérez Vos Souvenirs',
		'tutorial.souvenirs.manage.desc': 'Ajoutez, modifiez ou supprimez vos souvenirs facilement pour garder vos données à jour.',
		'tutorial.souvenirs.export': 'Exportez Vos Données',
		'tutorial.souvenirs.export.desc': 'Partez avec vos souvenirs de ChatGPT. Regardez ce tutoriel pour comprendre comment les récupérer en 30 secondes une fois l’extension liée à votre compte.',
		'tutorial.extension.install': 'Installer l\'Extension',
		'tutorial.extension.install.desc': 'L’extension Hiperyon vous permet d’ajouter des souvenirs en mémoire et d’effectuer des recherches.',
		'tutorial.extension.activate': 'Activer l\'Extension',
		'tutorial.extension.activate.desc': 'Une fois installée, liez l’extension avec le token de votre compte. Après cela, toutes les fonctionnalités de l’extension seront disponibles automatiquement.',
		'tutorial.extension.tutorial': 'Tutoriel Complet',
		'tutorial.extension.tutorial.desc': 'Regardez ce tutoriel pour comprendre comment lier l\'extension à votre compte.',
		'tutorial.extension.final': 'C\'est tout !',
		'tutorial.extension.final.desc': 'Vous êtes maintenant prêt à utiliser Hiperyon. Profitez de votre expérience améliorée !',
		'tutorial.button.previous': 'Précédent',
		'tutorial.button.next': 'Suivant',
		'tutorial.button.skip': 'Ignorer',
		'tutorial.button.done': 'Terminé',

		'auth.forgot.title': 'Réinitialiser le mot de passe',
		'auth.forgot.subtitle': 'Entrez votre email pour recevoir un lien',
		'auth.forgot.submit': 'Envoyer le lien',
		'auth.forgot.submitting': 'Envoi…',
		'auth.backToLogin': 'Retour à la connexion',
		'auth.forgot.success': 'Email envoyé',

		'auth.reset.title': 'Définir un nouveau mot de passe',
		'auth.reset.subtitle': "Entrez le code reçu par email et choisissez un nouveau mot de passe",
		'auth.reset.code': 'Code reçu',
		'auth.reset.newPassword': 'Nouveau mot de passe',
		'auth.reset.confirm': 'Confirmer le mot de passe',
		'auth.reset.submit': 'Réinitialiser le mot de passe',
		'auth.reset.submitting': 'Réinitialisation…',
		'auth.reset.errors.required': 'Tous les champs sont requis',
		'auth.reset.errors.mismatch': 'Les mots de passe ne correspondent pas',
		'auth.reset.success': 'Mot de passe réinitialisé avec succès',
		'auth.reset.redirectIn': 'Redirection dans {seconds}s…',

		'account.title': 'Mon Compte',
		'account.subtitle': 'Gérez vos informations et votre abonnement',
		'account.loading': 'Chargement de votre compte...',
		'account.updateSuccess': 'Profil mis à jour avec succès !',
		'account.personalInfo': 'Informations personnelles',
		'account.edit': 'Modifier',
		'account.cancel': 'Annuler',
		'account.save': 'Sauvegarder',
		'account.saving': 'Mise à jour...',
		'account.labels.pseudo': 'Pseudo',
		'account.labels.email': 'Email',
		'account.labels.nom': 'Nom',
		'account.labels.prenom': 'Prénom',
		'account.labels.dob': 'Date de naissance',
		'account.notProvided.masc': 'Non renseigné',
		'account.notProvided.fem': 'Non renseignée',
		'account.subscription.title': 'Mon Abonnement',
		'account.subscription.currentPlan': 'Plan actuel',
		'account.subscription.endDate': "Fin d'abonnement",
		'account.subscription.manage': 'Gérer mon abonnement',
		'account.subscription.none': 'Aucun abonnement actif',
		'account.subscription.viewPlans': 'Voir les plans',
		'account.logout': 'Se déconnecter',

		'pricing.header.badge': 'Tarifs',
		'pricing.header.title': 'Choisissez votre plan',
		'pricing.header.subtitle': 'Mensuel ou Annuel. En Annuel, profitez de 2 mois offerts.',
		'pricing.toggle.monthly': 'Mensuel',
		'pricing.toggle.yearly': 'Annuel',
		'pricing.yearly.badge': '2 mois offerts',
		'pricing.card.popular': 'Populaire',
		'pricing.per.month': 'mois',
		'pricing.per.year': 'an',
		'pricing.subscribe': "S'abonner",
		'pricing.already': 'Déjà abonné',
		'pricing.checking': 'Vérification…',
		'pricing.included': 'Inclus par défaut',
		'pricing.product': 'Produit:',
		'pricing.autorenew': 'Renouvellement auto par Stripe',

		// Nudge (proche limite)
		'nudge.title': 'Bientôt à la limite',
		'nudge.desc': "Vous serez bientôt à la limite de votre abonnement. Pensez à augmenter votre plan pour éviter toute interruption.",
		'nudge.btn.later': 'Plus tard',
		'nudge.btn.plans': 'Voir les plans',

		// Extension page
		'extension.title': 'Extension Hiperyon',
		'extension.subtitle': 'Votre IA mémorisante directement dans votre navigateur',
		'extension.status.title': "État de l'Extension",
		'extension.status.checking': 'Vérification...',
		'extension.status.installed': 'Installée',
		'extension.status.notInstalled': 'Non Installée',
		'extension.status.description.installed': "L'extension Hiperyon est installée et active sur ce navigateur.",
		'extension.status.description.notInstalled': "L'extension Hiperyon n'a pas été détectée sur ce navigateur",
		'extension.status.configuration': 'Configuration',
		'extension.status.chrome': 'Extension Chrome',
		'extension.status.chrome.detected': 'Extension détectée et active dans votre navigateur',
		'extension.status.chrome.notDetected': 'Extension non détectée dans votre navigateur',
		'extension.status.connected': 'Connecté',
		'extension.status.waiting': 'En attente',
		'extension.btn.installed': 'Extension installée',
		'extension.btn.install': "Installer l'Extension",
		'extension.btn.documentation': 'Documentation',
		'extension.howItWorks': 'Comment Ça Marche',
		'extension.step1.title': "Télécharger l'Extension",
		'extension.step1.description': 'Installez notre extension depuis le Chrome Web Store en quelques secondes.',
		'extension.step2.title': 'Connecter votre Compte',
		'extension.step2.description': "Liez l'extension à votre compte Hiperyon pour synchroniser vos données.",
		'extension.step2.link.title': "Lier l'extension",
		'extension.step2.link.description': 'Collez votre token ici pour connecter l\'extension',
		'extension.step2.token.placeholder': 'Collez votre token ici',
		'extension.step2.token.show': 'Afficher le token',
		'extension.step2.token.hide': 'Masquer le token',
		'extension.step2.token.copy': 'Copier',
		'extension.step2.token.copied': 'Token copié ✅',
		'extension.step2.token.error': 'Échec de la copie',
		'extension.step2.token.none': 'Aucun token à copier',
		'extension.step3.title': "Activer l'Extension",
		'extension.step3.description': "Sur votre site IA préféré (ChatGPT, Claude, etc.), placez votre curseur dans la barre de prompt et appuyez sur Ctrl+Q pour activer l'extension et enrichir vos conversations.",
		'extension.step4.title': "Profiter de l'IA Augmentée",
		'extension.step4.description': 'Vos conversations sont automatiquement enrichies par votre mémoire Hiperyon pour des réponses plus personnalisées.',
		'extension.tutorial.title': 'Besoin d\'aide ? Consultez notre tutoriel complet',
		'extension.tutorial.description': 'Apprenez à utiliser l\'extension étape par étape avec notre guide détaillé et nos exemples pratiques.',
		'extension.tutorial.btn': 'Voir le Tutoriel Complet',
		'extension.cta.title': 'Prêt à Booster Votre Expérience IA ?',
		'extension.cta.description': "Installez l'extension Hiperyon et transformez chaque conversation en souvenir durable.",
		'extension.cta.installNow': 'Installer Maintenant',
		'extension.cta.examples': 'Voir les exemples',
		'extension.notification.title': 'Extension Hiperyon',
		'extension.notification.notDetected': 'Non détectée',
		'extension.notification.description': '🚀 Boostez votre IA ! Installez l\'extension Hiperyon pour enrichir vos conversations avec ChatGPT, Claude et bien d\'autres grâce à votre mémoire personnelle.',
		'extension.notification.installNow': 'Installer Maintenant',
		'extension.notification.later': 'Plus tard',

		// DocExtension page
		'docext.title': "Guide complet : Installer et Lier l'Extension",
		'docext.subtitle': 'Guide détaillé, avec conseils de sécurité, FAQ et méthodes de dépannage.',
		'docext.nav.steps': 'Aller aux étapes :',
		'docext.summary.title': 'Résumé rapide',
		'docext.summary.intro': "Ce guide vous accompagne depuis une création de compte jusqu'à l'utilisation de l'extension Hiperyon. Suivez les étapes ci-dessous, puis consultez la FAQ et la section Dépannage si nécessaire.",
		'docext.summary.step1': "l'extension depuis le store.",
		'docext.summary.step2': 'votre token (Compte → Token).',
		'docext.summary.step3': 'le token dans l\'extension.',
		'docext.summary.step4': 'et tester sur un site de chat IA.',
		'docext.summary.install': 'Installer',
		'docext.summary.retrieve': 'Récupérer',
		'docext.summary.link': 'Lier',
		'docext.summary.verify': 'Vérifier',
		'docext.detailed.title': 'Étapes détaillées',
		'docext.step1.title': 'Installation (Chrome)',
		'docext.step1.p1': "Ouvrez le Chrome Web Store et recherchez « Hiperyon ». Cliquez sur",
		'docext.step1.p1.btn': 'Ajouter à Chrome',
		'docext.step1.p1.end': 'puis confirmez.',
		'docext.step1.p2': "Après installation, épinglez l'icône (cliquez l'icône puzzle → Épingler) pour y accéder rapidement.",
		'docext.step1.p3': 'Si vous utilisez un build local : ouvrez',
		'docext.step1.p3.mid': ', activez le mode développeur, puis',
		'docext.step1.p3.btn': "Charger l'extension non empaquetée",
		'docext.step1.p3.end': "et sélectionnez le dossier de l'extension.",
		'docext.step1.note': "Remarque : l'extension demande des permissions pour injecter du contenu et lire/écrire dans son propre stockage. C'est normal pour synchroniser votre token et interagir avec les pages de chat.",
		'docext.step2.title': 'Obtenir et gérer votre token',
		'docext.step2.p1': 'Sur le site Hiperyon, allez à la page',
		'docext.step2.p1.page': 'Extension',
		'docext.step2.p1.end': '(menu principal).',
		'docext.step2.p2': 'Sur cette page, vous trouverez un champ pour coller votre token : collez la valeur et cliquez sur',
		'docext.step2.p2.btn': 'Sauvegarder',
		'docext.step2.p3': "Si vous n'avez pas encore de token, générez-en un depuis",
		'docext.step2.p3.path': 'Compte → Token',
		'docext.step2.p3.end': ', puis revenez sur la page',
		'docext.step2.p3.page': 'Extension',
		'docext.step2.p3.final': 'pour le coller.',
		'docext.step2.p4': 'Gardez ce token secret : ne le partagez jamais. Si vous pensez qu\'il a été exposé, régénérez-le immédiatement.',
		'docext.step2.tip': 'Astuce : ce champ sur la page',
		'docext.step2.tip.page': 'Extension',
		'docext.step2.tip.end': 'du site est conçu pour les utilisateurs non techniques — facile à copier/coller.',
		'docext.step3.title': "Lier le token à l'extension",
		'docext.step3.p1': "Ouvrez l'extension en cliquant sur son icône puis sur",
		'docext.step3.p1.opt1': 'Options',
		'docext.step3.p1.or': 'ou',
		'docext.step3.p1.opt2': 'Settings',
		'docext.step3.p2': 'Cherchez le champ',
		'docext.step3.p2.field1': 'Token',
		'docext.step3.p2.or': 'ou',
		'docext.step3.p2.field2': 'API Key',
		'docext.step3.p2.end': ', collez le token et sauvegardez.',
		'docext.step3.p3': "L'extension peut proposer un bouton",
		'docext.step3.p3.btn': 'Tester la connexion',
		'docext.step3.p3.end': ': utilisez-le pour confirmer que le token est valide.',
		'docext.step3.note': "Rassurez-vous : le token est stocké localement dans votre navigateur par l'extension et n'est pas partagé publiquement.",
		'docext.step4.title': 'Vérification & utilisation',
		'docext.step4.p1': 'Ouvrez un site de chat IA (ex: chat.openai.com). Placez le curseur dans le prompt.',
		'docext.step4.p2': 'Utilisez le raccourci (par défaut',
		'docext.step4.p2.end': ') pour activer Hiperyon. L\'extension effectue une recherche et enrichit automatiquement le prompt avec votre mémoire. L\'ajout en mémoire se fait tout seul automatiquement. Vous pouvez désactiver ou contrôler cet ajout automatique par modèle IA via les permissions listées dans la popup de l\'extension (juste en dessous du token). Ces paramètres sont automatiquement sauvegardés.',
		'docext.security.title': 'Permissions & sécurité',
		'docext.security.web': 'Accès aux pages web :',
		'docext.security.web.desc': 'nécessaire pour détecter les zones de prompt et injecter l\'aide.',
		'docext.security.storage': 'Stockage local :',
		'docext.security.storage.desc': 'pour conserver votre token et préférences (localStorage / chrome.storage).',
		'docext.security.noleak': 'Jamais de fuite :',
		'docext.security.noleak.desc': 'le token reste côté client sauf si vous activez explicitement une synchronisation avec votre compte.',
		'docext.security.advice': 'Conseil : ne partagez jamais votre token et régénérez-le si vous avez le moindre doute.',
		'docext.faq.title': 'FAQ',
		'docext.faq.q1': 'Q: Où récupérer mon token ?',
		'docext.faq.a1': 'R: Dans',
		'docext.faq.a1.path': 'Compte → Token',
		'docext.faq.a1.end': "sur le site Hiperyon. Si l'option n'existe pas, vérifiez vos permissions ou contactez le support.",
		'docext.faq.q2': "Q: L'extension n'est pas détectée",
		'docext.faq.a2': "R: Vérifiez chrome://extensions, activez l'extension et relancez le navigateur. Essayez aussi d'épingler l'icône.",
		'docext.faq.q3': 'Q: Le token est invalide',
		'docext.faq.a3': "R: Régénérez le token depuis votre compte et remplacez la valeur dans l'extension.",
		'docext.checklist.title': 'Checklist',
		'docext.checklist.1': 'Compte Hiperyon créé et connecté',
		'docext.checklist.2': 'Extension installée et activée',
		'docext.checklist.3': 'Token généré et sauvegardé',
		'docext.checklist.4': 'Test effectué sur une page de chat',
		'docext.troubleshoot.title': 'Dépannage rapide',
		'docext.troubleshoot.1': 'Extension non visible :',
		'docext.troubleshoot.1.desc': "activez-la dans chrome://extensions et épinglez l'icône.",
		'docext.troubleshoot.2': 'Token rejeté :',
		'docext.troubleshoot.2.desc': 'régénérez et remplacez le token.',
		'docext.troubleshoot.3': 'Erreur console :',
		'docext.troubleshoot.3.desc': 'copiez le message et joignez-le au support pour accélérer le diagnostic.',
		'docext.troubleshoot.4': 'Conflit de raccourci :',
		'docext.troubleshoot.4.desc': "changez le raccourci dans les options de l'extension.",
		'docext.video.title': 'Tutoriel vidéo',
		'docext.video.desc': "Collez l'URL YouTube ou téléversez votre vidéo locale pour prévisualiser.",
		'docext.video.placeholder': 'https://youtube.com/watch?v=...',
		'docext.video.upload': 'Ou téléversez votre propre vidéo (aperçu local uniquement) :',
		'docext.video.remove': 'Supprimer',
		'docext.video.note': "Aperçu local — le fichier n'est pas envoyé au serveur.",
		'docext.video.installation.title': 'Tutoriel vidéo d\'installation',
		'docext.video.installation.desc': 'Regardez le tutoriel complet pour installer l\'extension Hiperyon sur votre navigateur.',
		'docext.video.synchronization.title': 'Tutoriel vidéo de synchronisation mémoire GPT',
		'docext.video.synchronization.desc': 'Regardez le tutoriel complet pour synchroniser votre mémoire ChatGPT avec Hiperyon.',
		'docext.contact': 'Pour assistance ou signaler un problème :',

		// Consentement aux cookies
		'cookies.title': '🍪 Consentement aux cookies',
		'cookies.message': 'Nous utilisons des cookies pour améliorer votre expérience, analyser le trafic et personnaliser le contenu. En cliquant sur "Accepter", vous consentez à l\'utilisation de tous les cookies.',
		'cookies.policyLabel': 'politique de confidentialité',
		'cookies.policyLink': '/politique-confidentialite',
		'cookies.moreInfo': 'pour plus de détails.',
		'cookies.reject': 'Refuser',
		'cookies.settings': 'Paramètres',
		'cookies.acceptAll': 'Accepter tout',
	},
	'en-US': {
		'nav.dashboard': 'Dashboard',
		'nav.memories': 'My Memories',
		'nav.libraries': 'Libraries',
		'nav.account': 'Account',
		'nav.pricing': 'Pricing',
		'nav.stats': 'Stats',
		'nav.settings': 'Settings',
		'nav.logout': 'Sign out',
		'nav.memory3d': 'Memory 3D',
		'nav.extension': 'Extension',

		'common.soon': 'Soon',
		'common.close': 'Close',
		'common.all': 'All',

		'actions.import': 'Import',
		'actions.add': 'Add',
		'actions.addDocuments': 'Add documents',
		'actions.importLink': 'Import link',
		'actions.save': 'Save',
		'actions.saving': 'Saving…',

		'common.loading': 'Loading…',
		'common.retry': 'Retry',
		'common.refresh': 'Refresh',
		'common.noData': 'No data.',

		'dashboard.subtitle': 'Manage your AI workspace',
		'dashboard.storage': 'Storage',
		'dashboard.vectorsUsed': 'Vectors used',
		'dashboard.spaceFree': '{percent}% free space left',
		'dashboard.memoryRequests': 'Memory requests',
		'dashboard.requestsOfQuota': 'of {quota} allowed',
		'dashboard.used': 'used',
		'dashboard.requestsRemaining': '{count} left this month',
		'dashboard.memoryHistory': 'Memory history',
		'dashboard.loadingMemories': 'Loading memories…',
		'dashboard.noMemories': 'No memory found.',
		'dashboard.viewAllHistory': 'View full history',
		'dashboard.aiPermissions': 'AI permissions',
		'dashboard.loadingPermissions': 'Loading permissions...',
		'dashboard.permissionsSaved': 'Permissions saved.',
		'dashboard.saveErrorPrefix': 'Save error:',

		// Limits reached
		'limits.title': 'Limit reached',
		'limits.desc': 'You have reached your free plan limit. Upgrade to keep going without interruptions.',
		'limits.reached.requests': '{used} / {quota} requests',
		'limits.reached.vectors': '{used} / {quota} vectors',
		'limits.btn.close': 'Close',
		'limits.btn.upgrade': 'See plans',
		'limits.btn.cleanup': 'Free up space',

		'stats.title': 'Stats',
		'stats.weeklyRequests': 'Requests (week)',
		'stats.requestsRemaining': '{remaining} left of {quota}',
		'stats.vectors': 'Vectors',
		'stats.vectorsRemaining': '{remaining} left of {quota}',
		'stats.distinctCategories': 'Distinct categories',
		'stats.basedOnHistory': 'Based on memory history',
		'stats.byCategory': 'Distribution by category',
		'stats.items': '{count} items',
		'stats.vectorCloud': '3D vector cloud',
		'stats.points': 'points',
		'stats.previewNote': 'Preview based on total_vectors.',
		'stats.loading': 'Loading stats…',

		'memory3d.title': 'Your Memory',
		'memory3d.subtitle': 'Dive into your thoughts and discover hidden memories',
		'memory3d.pointsShown': 'Points shown:',
		'memory3d.soonInputPlaceholder': 'Talk to your memory...',
		'memory3d.tooltipTitle': 'Chat with your memory',
		'memory3d.tooltipBody': 'Soon you will be able to query your memory to find info and answer personal questions',

		'settings.title': 'Settings',
		'settings.profile': 'Profile',
		'settings.language': 'Language',
		'settings.theme': 'Theme',

		'mcp.title': 'MCP server connection',
		'mcp.badge': 'Soon',
		'mcp.description': 'Create a token to authenticate with an MCP server. Server integration is coming soon.',
		'mcp.none': 'No token yet.',
		'mcp.copy': 'Copy',
		'mcp.delete': 'Delete',
		'mcp.createToken': 'Create token',
		'mcp.soonTitle': 'Coming soon',
		'mcp.soonText': 'MCP token creation is coming soon. Thank you for your patience.',

		'security.title': 'Security',
		'security.tip1': 'Your tokens are stored only in your browser.',
		'security.tip2': 'Sign out to clear authentication tokens.',

	'support.title': 'Support',
	'support.proText': 'If you have a problem with your subscription, contact: hiperyon@gmail.com',
	'support.discordButton': 'Discord Support',

		'library.title': 'Libraries',
		'library.intro1': 'Organize and include documents to enrich model answers. Files will be vectorized and searchable by your conversations.',
		'library.intro2': 'Feature in preparation. Try the actions below to see the preview.',
		'library.newLibrary': 'New Library',
		'library.noDocument': 'No document',
		'library.createdBy': 'Created by {email}',
		'library.count': '{count} librar{suffix}',
		'library.lastUpdated': 'Last updated',

		'notfound.title': 'Page not found',
		'notfound.text': 'The page you are looking for does not exist or has been moved.',
		'notfound.dashboard': 'Go to Dashboard',
		'notfound.memories': 'Memories',
		'notfound.libraries': 'Libraries',

		'souvenirs.title': 'My Memories',

		'auth.login.title': 'Sign in',
		'auth.login.subtitle': 'Welcome back',
		'auth.email': 'Email',
		'auth.password': 'Password',
		'auth.forgot': 'Forgot password?',
		'auth.or': 'or',
		'auth.login.submit': 'Sign in',
		'auth.login.submitting': 'Signing in...',
		'auth.login.noAccount': "Don't have an account?",
		'auth.signup.link': 'Create an account',
		'auth.error.server': 'Server connection error',
		'auth.error.invalid': 'Invalid credentials',

		'auth.signup.title': 'Create an account',
		'auth.signup.subtitle': 'Join us now',
		'auth.pseudo': 'Username',
		'auth.signup.submit': 'Create account',
		'auth.signup.submitting': 'Creating...',
		'auth.signup.success': 'Account created successfully! You can now sign in.',
		'auth.signup.haveAccount': 'Already have an account?',
		'auth.login.link': 'Sign in',
		'auth.password.strength': 'Password strength',
		'auth.password.veryWeak': 'Very weak',
		'auth.password.weak': 'Weak',
		'auth.password.medium': 'Medium',
		'auth.password.strong': 'Strong',
		'auth.password.requirement.min8': 'At least 8 characters',
		'auth.password.requirement.special': 'Special character (!@#$%...)',
		'auth.password.requirement.uppercase': 'Uppercase letter (A-Z)',
		'auth.password.requirement.number': 'Number (0-9)',

		// Onboarding
		'onboarding.step': 'Step',
		'onboarding.welcome': 'Welcome to Hiperyon',
		'onboarding.welcomeDesc': 'Thank you for helping us get to know you better',
		'onboarding.helpDesc': 'This information helps us personalize your experience',
		'onboarding.ageQuestion': 'What is your age?',
		'onboarding.ageHelper': 'You can skip this step if you prefer',
		'onboarding.usageQuestion': 'What is your primary usage?',
		'onboarding.usageHelper': 'This helps optimize recommended models',
		'onboarding.modelQuestion': 'Which LLMs do you use?',
		'onboarding.modelHelper': 'Select all models you use regularly',
		'onboarding.frequenceQuestion': 'How many days per week?',
		'onboarding.frequenceHelper': 'Approximately how many days per week do you use an LLM?',
		'onboarding.frequence1day': '1 day',
		'onboarding.frequence2to3': '2-3 days',
		'onboarding.frequence4to5': '4-5 days',
		'onboarding.frequence5plus': 'More than 5 days',
		'onboarding.subscriptionQuestion': 'Choose your subscription',
		'onboarding.subscriptionRecommendLow': 'The Voyageur plan is perfect to get started.',
		'onboarding.subscriptionRecommendMed': 'You use AI often. The Pro plan is ideal for you.',
		'onboarding.subscriptionRecommendHigh': 'You use AI very regularly! We recommend the Max plan.',
		'onboarding.yourProfile': 'Your profile',
		'onboarding.age': 'Age',
		'onboarding.usage': 'Usage',
		'onboarding.model': 'Model',
		'onboarding.frequence': 'Frequency',
		'onboarding.notSet': 'Not set',
		'onboarding.calculating': 'We are calculating the best subscription',
		'onboarding.calculatingDesc': 'Based on your profile, we find the most suitable offer for you...',
		'onboarding.chooseLater': 'Choose later',
		'onboarding.next': 'Next',
		'onboarding.back': 'Back',
		'onboarding.skip': 'Skip',
		'onboarding.planVoyageur': 'Voyageur',
		'onboarding.planPro': 'Pro',
		'onboarding.planMax': 'Max',
		'onboarding.planFree': 'Free',
		'onboarding.recommended': 'Recommended',
		'onboarding.popular': 'Popular',
		'onboarding.usageWork': 'Work & Productivity',
		'onboarding.usageStudy': 'Studies & Learning',
		'onboarding.usagePersonal': 'Personal Use',

		// Tutorial
		'tutorial.dashboard.welcome': 'Welcome to Hiperyon',
		'tutorial.dashboard.welcome.desc': 'Learn how to use Hiperyon in 2 minutes.',
		'tutorial.dashboard.storage': 'Your Storage Space',
		'tutorial.dashboard.storage.desc': 'Track your vector usage. 1 vector = 1 memory stored.',
		'tutorial.dashboard.requests': 'Memory Requests',
		'tutorial.dashboard.requests.desc': 'Each question to your memory uses one request. Adding a memory also uses one request.',
		'tutorial.dashboard.permissions': 'AI Permissions',
		'tutorial.dashboard.permissions.desc': 'Control for each AI whether its models can add data to your memory or read from your memory.',
		'tutorial.dashboard.video': 'Watch this tutorial to better understand the dashboard.',
		'tutorial.souvenirs.title': 'My Memories',
		'tutorial.souvenirs.title.desc': 'Your personal database of information stored in Hiperyon.',
		'tutorial.souvenirs.manage': 'Manage Your Memories',
		'tutorial.souvenirs.manage.desc': 'Easily add, edit, or delete your memories to keep your data up to date.',
		'tutorial.souvenirs.export': 'Export Your Data',
		'tutorial.souvenirs.export.desc': 'Take your ChatGPT memories with you. Watch this tutorial to learn how to retrieve them in 30 seconds once the extension is linked to your account.',
		'tutorial.extension.install': 'Install the Extension',
		'tutorial.extension.install.desc': 'The Hiperyon extension lets you add memories and search through them.',
		'tutorial.extension.activate': 'Activate the Extension',
		'tutorial.extension.activate.desc': 'Once installed, link the extension with your account token. After that, all extension features will be available automatically.',
		'tutorial.extension.tutorial': 'Complete Tutorial',
		'tutorial.extension.tutorial.desc': 'Watch this tutorial to learn how to link the extension to your account.',
		'tutorial.extension.final': 'You\'re All Set!',
		'tutorial.extension.final.desc': 'You are now ready to use Hiperyon. Enjoy your enhanced experience!',
		'tutorial.button.previous': 'Previous',
		'tutorial.button.next': 'Next',
		'tutorial.button.skip': 'Skip',
		'tutorial.button.done': 'Done',

		'auth.forgot.title': 'Reset password',
		'auth.forgot.subtitle': 'Enter your email to receive a link',
		'auth.forgot.submit': 'Send link',
		'auth.forgot.submitting': 'Sending…',
		'auth.backToLogin': 'Back to sign in',
		'auth.forgot.success': 'Email sent',

		'auth.reset.title': 'Set a new password',
		'auth.reset.subtitle': 'Enter the code you received by email and choose a new password',
		'auth.reset.code': 'Code received',
		'auth.reset.newPassword': 'New password',
		'auth.reset.confirm': 'Confirm password',
		'auth.reset.submit': 'Reset password',
		'auth.reset.submitting': 'Resetting…',
		'auth.reset.errors.required': 'All fields are required',
		'auth.reset.errors.mismatch': 'Passwords do not match',
		'auth.reset.success': 'Password reset successfully',
		'auth.reset.redirectIn': 'Redirecting in {seconds}s…',

		'account.title': 'My Account',
		'account.subtitle': 'Manage your information and subscription',
		'account.loading': 'Loading your account...',
		'account.updateSuccess': 'Profile updated successfully!',
		'account.personalInfo': 'Personal information',
		'account.edit': 'Edit',
		'account.cancel': 'Cancel',
		'account.save': 'Save',
		'account.saving': 'Updating...',
		'account.labels.pseudo': 'Username',
		'account.labels.email': 'Email',
		'account.labels.nom': 'Last name',
		'account.labels.prenom': 'First name',
		'account.labels.dob': 'Birth date',
		'account.notProvided.masc': 'Not provided',
		'account.notProvided.fem': 'Not provided',
		'account.subscription.title': 'My Subscription',
		'account.subscription.currentPlan': 'Current plan',
		'account.subscription.endDate': 'Subscription end',
		'account.subscription.manage': 'Manage my subscription',
		'account.subscription.none': 'No active subscription',
		'account.subscription.viewPlans': 'See plans',
		'account.logout': 'Sign out',

		'pricing.header.badge': 'Pricing',
		'pricing.header.title': 'Choose your plan',
		'pricing.header.subtitle': 'Monthly or Yearly. On Yearly, enjoy 2 months free.',
		'pricing.toggle.monthly': 'Monthly',
		'pricing.toggle.yearly': 'Yearly',
		'pricing.yearly.badge': '2 months free',
		'pricing.card.popular': 'Popular',
		'pricing.per.month': 'month',
		'pricing.per.year': 'year',
		'pricing.subscribe': 'Subscribe',
		'pricing.already': 'Already subscribed',
		'pricing.checking': 'Checking…',
		'pricing.included': 'Included by default',
		'pricing.product': 'Product:',
		'pricing.autorenew': 'Auto-renew by Stripe',

		// Nudge (near limit)
		'nudge.title': 'Almost at your limit',
		'nudge.desc': 'You are getting close to your plan limit. Consider upgrading to avoid interruptions.',
		'nudge.btn.later': 'Later',
		'nudge.btn.plans': 'See plans',

		// Extension page
		'extension.title': 'Hiperyon Extension',
		'extension.subtitle': 'Your memorizing AI directly in your browser',
		'extension.status.title': 'Extension Status',
		'extension.status.checking': 'Checking...',
		'extension.status.installed': 'Installed',
		'extension.status.notInstalled': 'Not Installed',
		'extension.status.description.installed': 'The Hiperyon extension is installed and active on this browser.',
		'extension.status.description.notInstalled': 'The Hiperyon extension was not detected on this browser',
		'extension.status.configuration': 'Configuration',
		'extension.status.chrome': 'Chrome Extension',
		'extension.status.chrome.detected': 'Extension detected and active in your browser',
		'extension.status.chrome.notDetected': 'Extension not detected in your browser',
		'extension.status.connected': 'Connected',
		'extension.status.waiting': 'Waiting',
		'extension.btn.installed': 'Extension installed',
		'extension.btn.install': 'Install Extension',
		'extension.btn.documentation': 'Documentation',
		'extension.howItWorks': 'How It Works',
		'extension.step1.title': 'Download the Extension',
		'extension.step1.description': 'Install our extension from the Chrome Web Store in seconds.',
		'extension.step2.title': 'Connect your Account',
		'extension.step2.description': 'Link the extension to your Hiperyon account to sync your data.',
		'extension.step2.link.title': 'Link the extension',
		'extension.step2.link.description': 'Paste your token here to connect the extension',
		'extension.step2.token.placeholder': 'Paste your token here',
		'extension.step2.token.show': 'Show token',
		'extension.step2.token.hide': 'Hide token',
		'extension.step2.token.copy': 'Copy',
		'extension.step2.token.copied': 'Token copied ✅',
		'extension.step2.token.error': 'Copy failed',
		'extension.step2.token.none': 'No token to copy',
		'extension.step3.title': 'Activate the Extension',
		'extension.step3.description': 'On your favorite AI site (ChatGPT, Claude, etc.), place your cursor in the prompt bar and press Ctrl+Q to activate the extension and enrich your conversations.',
		'extension.step4.title': 'Enjoy Augmented AI',
		'extension.step4.description': 'Your conversations are automatically enriched by your Hiperyon memory for more personalized responses.',
		'extension.tutorial.title': 'Need help? Check out our complete tutorial',
		'extension.tutorial.description': 'Learn how to use the extension step by step with our detailed guide and practical examples.',
		'extension.tutorial.btn': 'View Complete Tutorial',
		'extension.cta.title': 'Ready to Boost Your AI Experience?',
		'extension.cta.description': 'Install the Hiperyon extension and turn every conversation into lasting memory.',
		'extension.cta.installNow': 'Install Now',
		'extension.cta.examples': 'See Examples',
		'extension.notification.title': 'Hiperyon Extension',
		'extension.notification.notDetected': 'Not detected',
		'extension.notification.description': '🚀 Boost your AI! Install the Hiperyon extension to enrich your conversations with ChatGPT, Claude and many others with your personal memory.',
		'extension.notification.installNow': 'Install Now',
		'extension.notification.later': 'Later',

		// DocExtension page
		'docext.title': 'Complete Guide: Install and Link the Extension',
		'docext.subtitle': 'Detailed guide with security tips, FAQ, and troubleshooting methods.',
		'docext.nav.steps': 'Go to steps:',
		'docext.summary.title': 'Quick Summary',
		'docext.summary.intro': 'This guide takes you from account creation to using the Hiperyon extension. Follow the steps below, then check the FAQ and Troubleshooting section if needed.',
		'docext.summary.step1': 'the extension from the store.',
		'docext.summary.step2': 'your token (Account → Token).',
		'docext.summary.step3': 'the token in the extension.',
		'docext.summary.step4': 'and test on an AI chat site.',
		'docext.summary.install': 'Install',
		'docext.summary.retrieve': 'Retrieve',
		'docext.summary.link': 'Link',
		'docext.summary.verify': 'Verify',
		'docext.detailed.title': 'Detailed Steps',
		'docext.step1.title': 'Installation (Chrome)',
		'docext.step1.p1': 'Open the Chrome Web Store and search for "Hiperyon". Click on',
		'docext.step1.p1.btn': 'Add to Chrome',
		'docext.step1.p1.end': 'then confirm.',
		'docext.step1.p2': 'After installation, pin the icon (click the puzzle icon → Pin) for quick access.',
		'docext.step1.p3': 'If you are using a local build: open',
		'docext.step1.p3.mid': ', enable developer mode, then',
		'docext.step1.p3.btn': 'Load unpacked extension',
		'docext.step1.p3.end': 'and select the extension folder.',
		'docext.step1.note': 'Note: the extension requests permissions to inject content and read/write to its own storage. This is normal to sync your token and interact with chat pages.',
		'docext.step2.title': 'Get and manage your token',
		'docext.step2.p1': 'On the Hiperyon site, go to the',
		'docext.step2.p1.page': 'Extension',
		'docext.step2.p1.end': 'page (main menu).',
		'docext.step2.p2': 'On this page, you will find a field to paste your token: paste the value and click',
		'docext.step2.p2.btn': 'Save',
		'docext.step2.p3': "If you don't have a token yet, generate one from",
		'docext.step2.p3.path': 'Account → Token',
		'docext.step2.p3.end': ', then return to the',
		'docext.step2.p3.page': 'Extension',
		'docext.step2.p3.final': 'page to paste it.',
		'docext.step2.p4': 'Keep this token secret: never share it. If you think it has been exposed, regenerate it immediately.',
		'docext.step2.tip': 'Tip: this field on the',
		'docext.step2.tip.page': 'Extension',
		'docext.step2.tip.end': 'page of the site is designed for non-technical users — easy to copy/paste.',
		'docext.step3.title': 'Link the token to the extension',
		'docext.step3.p1': 'Open the extension by clicking on its icon then on',
		'docext.step3.p1.opt1': 'Options',
		'docext.step3.p1.or': 'or',
		'docext.step3.p1.opt2': 'Settings',
		'docext.step3.p2': 'Look for the field',
		'docext.step3.p2.field1': 'Token',
		'docext.step3.p2.or': 'or',
		'docext.step3.p2.field2': 'API Key',
		'docext.step3.p2.end': ', paste the token and save.',
		'docext.step3.p3': 'The extension may offer a button',
		'docext.step3.p3.btn': 'Test connection',
		'docext.step3.p3.end': ': use it to confirm that the token is valid.',
		'docext.step3.note': 'Rest assured: the token is stored locally in your browser by the extension and is not shared publicly.',
		'docext.step4.title': 'Verification & use',
		'docext.step4.p1': 'Open an AI chat site (e.g. chat.openai.com). Place the cursor in the prompt.',
		'docext.step4.p2': 'Use the shortcut (default',
		'docext.step4.p2.end': ') to activate Hiperyon. The extension automatically searches and enriches your prompt with your memory. Memory is added automatically by default. You can disable or control this automatic addition per AI model via the permissions listed in the extension popup (just below the token field). These settings are automatically saved.',
		'docext.security.title': 'Permissions & security',
		'docext.security.web': 'Web page access:',
		'docext.security.web.desc': 'required to detect prompt areas and inject help.',
		'docext.security.storage': 'Local storage:',
		'docext.security.storage.desc': 'to store your token and preferences (localStorage / chrome.storage).',
		'docext.security.noleak': 'No leak:',
		'docext.security.noleak.desc': 'the token stays on the client side unless you explicitly enable synchronization with your account.',
		'docext.security.advice': 'Tip: never share your token and regenerate it if you have any doubt.',
		'docext.faq.title': 'FAQ',
		'docext.faq.q1': 'Q: Where to get my token?',
		'docext.faq.a1': 'A: In',
		'docext.faq.a1.path': 'Account → Token',
		'docext.faq.a1.end': "on the Hiperyon site. If the option doesn't exist, check your permissions or contact support.",
		'docext.faq.q2': 'Q: Extension is not detected',
		'docext.faq.a2': 'A: Check chrome://extensions, enable the extension and restart the browser. Also try pinning the icon.',
		'docext.faq.q3': 'Q: The token is invalid',
		'docext.faq.a3': 'A: Regenerate the token from your account and replace the value in the extension.',
		'docext.checklist.title': 'Checklist',
		'docext.checklist.1': 'Hiperyon account created and connected',
		'docext.checklist.2': 'Extension installed and enabled',
		'docext.checklist.3': 'Token generated and saved',
		'docext.checklist.4': 'Test performed on a chat page',
		'docext.troubleshoot.title': 'Quick troubleshooting',
		'docext.troubleshoot.1': 'Extension not visible:',
		'docext.troubleshoot.1.desc': 'enable it in chrome://extensions and pin the icon.',
		'docext.troubleshoot.2': 'Token rejected:',
		'docext.troubleshoot.2.desc': 'regenerate and replace the token.',
		'docext.troubleshoot.3': 'Console error:',
		'docext.troubleshoot.3.desc': 'copy the message and attach it to support to speed up diagnosis.',
		'docext.troubleshoot.4': 'Shortcut conflict:',
		'docext.troubleshoot.4.desc': 'change the shortcut in the extension options.',
		'docext.video.title': 'Video tutorial',
		'docext.video.desc': 'Paste the YouTube URL or upload your local video to preview.',
		'docext.video.placeholder': 'https://youtube.com/watch?v=...',
		'docext.video.upload': 'Or upload your own video (local preview only):',
		'docext.video.remove': 'Remove',
		'docext.video.note': 'Local preview — the file is not sent to the server.',
		'docext.video.installation.title': 'Installation video tutorial',
		'docext.video.installation.desc': 'Watch the complete tutorial to install the Hiperyon extension on your browser.',
		'docext.video.synchronization.title': 'GPT memory synchronization video tutorial',
		'docext.video.synchronization.desc': 'Watch the complete tutorial to synchronize your ChatGPT memory with Hiperyon.',
		'docext.contact': 'For assistance or to report a problem:',

		// Cookie consent
		'cookies.title': '🍪 Cookie Consent',
		'cookies.message': 'We use cookies to improve your experience, analyze traffic, and personalize content. By clicking "Accept All", you consent to the use of all cookies.',
		'cookies.policyLabel': 'privacy policy',
		'cookies.policyLink': '/privacy-policy',
		'cookies.moreInfo': 'for more details.',
		'cookies.reject': 'Reject',
		'cookies.settings': 'Settings',
		'cookies.acceptAll': 'Accept All',
	},
};

const I18nContext = createContext({
	locale: 'fr-FR',
	setLocale: () => {},
	t: (key, vars) => key,
});

export function I18nProvider({ children }) {
	const initial = useMemo(() => {
		const saved = typeof window !== 'undefined' ? localStorage.getItem('locale') : null;
		if (saved && messages[saved]) return saved;
		const nav = typeof navigator !== 'undefined' ? navigator.language : 'fr-FR';
		return nav?.startsWith('en') ? 'en-US' : 'fr-FR';
	}, []);

	const [locale, setLocaleState] = useState(initial);

	useEffect(() => {
		if (typeof document !== 'undefined') {
			document.documentElement.lang = locale.startsWith('en') ? 'en' : 'fr';
		}
		if (typeof window !== 'undefined') {
			localStorage.setItem('locale', locale);
		}
	}, [locale]);

	const setLocale = (loc) => {
		if (messages[loc]) setLocaleState(loc);
	};

	const t = (key, vars = {}) => {
		const dict = messages[locale] || {};
		let out = dict[key] || key;
		Object.keys(vars).forEach(k => {
			out = out.replace(new RegExp(`\\{${k}\\}`, 'g'), String(vars[k]));
		});
		if (vars.count !== undefined && out.includes('{suffix}')) {
			const n = Number(vars.count);
			const suffix = locale === 'fr-FR' ? (n > 1 ? 's' : '') : (n === 1 ? 'y' : 'ies');
			out = out.replace('{suffix}', suffix);
		}
		return out;
	};

	const value = useMemo(() => ({ locale, setLocale, t }), [locale]);
	return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export function useI18n() {
	return useContext(I18nContext);
}

